export default {
    'name': 'desc',
    'label': 'patent-view.DESC',
    'getComponent': () => import('./Description.vue'),
    'tabIndex': 2,
    'left': true,
    'right': true,
    'singleView': true,
    'compareView': true,
    'exclusiveRoutePath': '/desc',
    'enableDensity': true,
};
